import useRestAPI from '../useRestAPI';
import useConfig from '../useConfig';
import {useQuery} from '@tanstack/react-query';
import useCountry from '../useCountry';
import {EntrypointsResponse} from '../../api/entrypoint-service/EntrypointsResponse';
import {CountryCodeType} from '../../model';

export const useEntryPoint = (countryOverride?: CountryCodeType) => {
  const config = useConfig();
  const country = useCountry();
  const countryCode = countryOverride ?? country.code;
  const api = useRestAPI();

  const query = useQuery({
    queryKey: ['entrypoint', countryCode],
    queryFn: async () => {
      const url = new URL(
        `${config.links.entrypoint}${countryCode?.toLowerCase() ?? 'se'}`,
      );
      url.searchParams.set('version', config.clientVersion);
      url.searchParams.set('device', config.clientPlatform);
      return await api.client.getJSONBody<EntrypointsResponse>(url.toString(), {
        Authorization: '',
      });
    },
  });

  return {query};
};

export default useEntryPoint;
